// TODO: insert live domain and tag manager id
let liveDomain = 'kosmos-campus.de';
let tagManagerId = 'GTM-XXXXXX';
let cookieInformationElem;

function acceptTrackingCookies() {
  console.log('acceptTrackingCookies');
  setCookie('acceptrackingcookies', '1');
  if (window.location.hostname.includes(liveDomain)) {
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src =
        'https://www.googletagmanager.com/gtm.js?id=' +
        i +
        dl +
        '&gtm_auth=RnNaAPxQYpKTbeHwL8JTiw&gtm_preview=env-2&gtm_cookies_win=x';
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-KSTJTZB');
  } else if (
    window.location.hostname.includes('staging.hatchery.io') ||
    window.location.hostname.includes('staging2.hatchery.io')
  ) {
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src =
        'https://www.googletagmanager.com/gtm.js?id=' +
        i +
        dl +
        '&gtm_auth=iKlBT1c_j8nBgX5eS2Zy0Q&gtm_preview=env-5&gtm_cookies_win=x';
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-NGBVBN8');
  }
  window[`ga-disable-${tagManagerId}`] = false;
  hideCookieBanner();
}

function disagreeTrackingCookies() {
  console.log('disagreeTrackingCookies');
  setCookie('acceptrackingcookies', '0');
  window[`ga-disable-${tagManagerId}`] = true;
}

function acceptYoutubeCookies() {
  console.log('acceptYoutubeCookies');
  setCookie('acceptyoutubecookies', '1');
  Array.from(document.querySelectorAll('.youtube-cookies-info')).forEach(el => el.classList.add('is-hidden'));
  Array.from(document.querySelectorAll('.iframe-youtube-video')).forEach(el => {
    el.classList.remove('is-hidden');
    el.src = el.dataset.src;
  });
}

function disagreeYoutubeCookies() {
  console.log('disagreeYoutubeCookies');
  setCookie('acceptyoutubecookies', '0');
  Array.from(document.querySelectorAll('.youtube-cookies-info')).forEach(el => el.classList.remove('is-hidden'));
  Array.from(document.querySelectorAll('.iframe-youtube-video')).forEach(el => {
    el.classList.add('is-hidden');
    el.src = '';
  });
}

function acceptAllCookies() {
  acceptYoutubeCookies();
  acceptTrackingCookies();
  hideCookieBanner();
}

function hideCookieBanner() {
  setCookie('hidecookieinfo', '1');
  cookieInformationElem.style.display = 'none';
}

function setCookie(name, value) {
  let d = new Date();
  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = `${name}=${value};path=/;` + expires;
}

function showCookieSettings() {
  cookieInformationElem = document.querySelector('#cookies-information');
  if (document.cookie.indexOf('acceptrackingcookies=1') !== -1) {
    cookieInformationElem.querySelector('#tracking-cookies').checked = true;
  } else {
    cookieInformationElem.querySelector('#tracking-cookies').checked = false;
  }
  if (document.cookie.indexOf('acceptyoutubecookies=1') !== -1) {
    cookieInformationElem.querySelector('#youtube-cookies').checked = true;
  } else {
    cookieInformationElem.querySelector('#youtube-cookies').checked = false;
  }
  cookieInformationElem.style.display = 'flex';
}

document.addEventListener('DOMContentLoaded', function() {
  cookieInformationElem = document.querySelector('#cookies-information');

  if (!cookieInformationElem) {
    return;
  }

  // Reset cookies buttons
  document.querySelectorAll('.btn-reset-cookies').forEach(el => {
    el.addEventListener('click', () => {
      showCookieSettings();
    });
  });

  // Logic to only activate selected cookies
  cookieInformationElem.querySelector('#btn-accept-selected').addEventListener('click', () => {
    const checkboxEls = cookieInformationElem.querySelectorAll('.checkboxes-container input');
    const allowTracking = Array.from(checkboxEls).some(el => el.value === 'tracking' && el.checked);
    const allowYoutube = Array.from(checkboxEls).some(el => el.value === 'youtube' && el.checked);
    if (allowYoutube) {
      acceptYoutubeCookies();
    } else {
      disagreeYoutubeCookies();
    }
    if (allowTracking) {
      acceptTrackingCookies();
    } else {
      disagreeTrackingCookies();
    }
    hideCookieBanner();
  });

  cookieInformationElem.querySelector('#btn-accept-all').addEventListener('click', acceptAllCookies);
  // Show popup if user is trying to unselect the required option
  cookieInformationElem.querySelector('label[for="required-cookies"]').addEventListener('click', function() {
    alert(this.title);
  });

  Array.from(document.querySelectorAll('.btn-accept-youtube-cookies')).forEach(el => {
    el.addEventListener('click', acceptYoutubeCookies);
  });

  if (document.cookie.indexOf('hidecookieinfo=1') === -1) {
    const path = window.location.pathname.split('/');
    if (path.includes('privacy') || path.includes('datenschutz')) {
      cookieInformationElem.style.display = 'none';
    } else {
      cookieInformationElem.style.display = 'flex';
    }
  } else {
    if (document.cookie.indexOf('acceptrackingcookies=1') !== -1) {
      acceptTrackingCookies();
    } else {
      disagreeTrackingCookies();
    }
    if (document.cookie.indexOf('acceptyoutubecookies=1') !== -1) {
      acceptYoutubeCookies();
    } else {
      disagreeYoutubeCookies();
    }
    hideCookieBanner();
  }
});
